/**
 * Is this a sign-in-by-link arrival?
 *
 * `App` holds the whole application behind a gate while it exchanges a
 * `redirectToken` for a session. The gate used to trigger on *any* query
 * parameter, and its failure branch is a hard `window.location.href = "/"`,
 * which drops the query string on the way.
 *
 * So a signed-out visitor arriving with any parameter at all was bounced to `/`
 * with it stripped. That silently broke `/?signup=1`, the deep link used by
 * shared sign-up links and the mobile in-app browser: `Role` then saw no
 * `signup` parameter and sent them to `/login` (ECH-375). It would equally
 * discard campaign or referral parameters on any public URL.
 *
 * The gate exists for one flow, so it tests for that flow. Both parameters are
 * required because the exchange needs both, and one without the other is not a
 * link arrival to wait for.
 */
export const isRedirectTokenLink = (queryParams) =>
  Boolean(queryParams?.get("userId") && queryParams?.get("redirectToken"));

export default isRedirectTokenLink;
